/* Herbally homepage order layer (Sep 24). Pack buttons and the sticky Order Now bar open the product page with that pack selected and scroll to the COD order form (#hbOrder). No Shopify checkout from the homepage. */
(function () {
  'use strict';
  if (window.__hbxHome) { return; }
  window.__hbxHome = true;

  var PRODUCT = '/products/sugar-care-herbal-supplement';
  var UR = 'Noto Nastaliq Urdu,Jameel Noori Nastaleeq,Arial,sans-serif';

  function guard(fn) { try { fn(); } catch (e) { /* never break the page */ } }
  function ready(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.appendChild(document.createTextNode(text)); }
    return n;
  }
  function go(qty) { window.location.href = PRODUCT + '?pack=' + (qty > 0 ? qty : 1) + '#hbOrder'; }

  function packQty(a) {
    var cards = document.querySelectorAll('.hb-bundle-grid .hb-card'), i;
    for (i = 0; i < cards.length; i++) { if (cards[i].contains(a)) { return i + 1; } }
    return 0;
  }
  function onClick(e) {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var t = e.target;
    if (!t || !t.closest) { return; }
    var bar = t.closest('.hbx-hbar__btn');
    var a = t.closest('.hb-bundle-grid .hb-card a.hb-btn');
    var qty = 0;
    if (bar) { qty = 1; } else if (a) { qty = packQty(a); }
    if (!qty) { return; }
    e.preventDefault();
    go(qty);
  }

  function addStyle() {
    var css = ''
      + '.hbx-hbar{position:fixed;left:0;right:0;bottom:0;z-index:99990;display:flex;align-items:center;gap:10px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -8px 24px rgba(0,0,0,.15);border-top:1px solid rgba(230,194,0,.35);transform:translateY(115%);transition:transform .25s ease;visibility:hidden}'
      + '.hbx-hbar.hbx-on{transform:translateY(0);visibility:visible}'
      + '.hbx-hbar__info{display:flex;flex-direction:column;line-height:1.2;flex:0 0 auto;min-width:76px}'
      + '.hbx-hbar__price{font-size:15px;font-weight:900;color:#c0161d}'
      + '.hbx-hbar__name{font-size:10px;font-weight:700;color:#6b6b6b}'
      + '.hbx-hbar__name span{display:block;direction:rtl;font-family:' + UR + ';font-size:9.5px;color:#8a7d55}'
      + '.hbx-hbar__btn{flex:1 1 auto;border:none;cursor:pointer;padding:13px 18px;border-radius:14px;background:linear-gradient(135deg,#2f8a17,#154a09 55%,#0d2415);box-shadow:0 10px 22px rgba(19,56,5,.35);color:#fff;font-weight:800;font-size:14px;display:flex;flex-direction:column;align-items:center;gap:1px}'
      + '.hbx-hbar__btn span+span{direction:rtl;font-family:' + UR + ';font-size:11px;font-weight:600;opacity:.9}'
      + '.hbx-hbar__btn:active{transform:scale(.97)}'
      + 'body.hbx-has-bar [class^=ai-whatsapp-float-],body.hbx-has-bar .scroll-to-top-btn{margin-bottom:76px}'
      + '@media(min-width:750px){.hbx-hbar{max-width:480px;left:auto;right:24px;bottom:24px;border-radius:20px;border:1px solid rgba(230,194,0,.4)}}'
      + '@media(max-width:420px){.hb-bundle-grid .hb-card:nth-child(4) .hb-bottles img{height:118px}.hb-bundle-grid .hb-card:nth-child(4) .hb-bottles img:nth-child(n+2){margin-left:-28px}}'
      + '@media(max-width:340px){.hb-bundle-grid .hb-card:nth-child(4) .hb-bottles img{height:104px}}';
    var s = document.createElement('style');
    s.setAttribute('data-hbx-home', '1');
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  function buildBar() {
    if (document.getElementById('hbxBar')) { return null; }
    var priceEl = document.querySelector('.hb-bundle-grid .hb-card .hb-price');
    var bar = el('div', 'hbx-hbar');
    bar.id = 'hbxBar';
    var info = el('div', 'hbx-hbar__info');
    if (priceEl && priceEl.textContent) { info.appendChild(el('span', 'hbx-hbar__price', priceEl.textContent.replace(/^ +| +$/g, ''))); }
    var name = el('span', 'hbx-hbar__name', 'Sugar Care');
    var nameUr = el('span', '', 'شوگر کیئر');
    nameUr.setAttribute('dir', 'rtl');
    name.appendChild(nameUr);
    info.appendChild(name);
    var btn = el('button', 'hbx-hbar__btn');
    btn.type = 'button';
    btn.appendChild(el('span', '', 'Order Now'));
    var btnUr = el('span', '', 'ابھی آرڈر کریں');
    btnUr.setAttribute('dir', 'rtl');
    btn.appendChild(btnUr);
    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    return bar;
  }

  function initBar() {
    var bar = buildBar();
    if (!bar) { return; }
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var full = document.documentElement.scrollHeight || 0;
      var nearBottom = full > 0 && (y + window.innerHeight) >= (full - 160);
      var on = y > 320 && !nearBottom;
      bar.classList.toggle('hbx-on', on);
      document.body.classList.toggle('hbx-has-bar', on);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  ready(function () {
    if (!document.querySelector('.hb-bundle-grid') && !document.querySelector('.hb-hero')) { return; }
    guard(addStyle);
    document.addEventListener('click', function (e) { guard(function () { onClick(e); }); }, true);
    guard(initBar);
  });
})();
